import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Popover,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";
import { HexColorPicker } from "react-colorful";
import { getContrastYIQ } from "../../Utils/color.utils";
import { setCourses } from "../../Endpoints";
import { SET_COURSES } from "../../Constants/reducerEvents";
import { useOutsideClick } from "../../Utils/customHooks";
import { v4 as uuidv4 } from "uuid";

export default function Courses() {
  const courses = useSelector((state) => state.courses);
  const [newCourses, setNewCourses] = useState(courses);
  const [current, setCurrent] = useState(null);
  const popoverAnchor = useRef(null);
  const popOver = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    function handleClickOutside(event) {
      if (popOver.current && !popOver.current.contains(event.target)) {
        setCurrent(null);
        popoverAnchor.current = null;
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popOver]);

  const saveCourses = () => {
    dispatch({ type: SET_COURSES, payload: newCourses });
  };
  const openColor = (id) => {
    setCurrent(id);
    popoverAnchor.current = document.getElementById(`color-button-${id}`);
  };

  const getCourseStyle = (color) => {
    return {
      backgroundColor: color ? color : "white",
      color: color ? getContrastYIQ(color) : "black",
    };
  };
  const updateName = (id, name) => {
    setNewCourses((cs) =>
      cs.map((c) => {
        if (c.id === id) {
          return { ...c, name: name };
        }
        return c;
      })
    );
  };
  const updateColor = (id, color) => {
    setNewCourses((cs) =>
      cs.map((c) => {
        if (c.id === id) {
          return { ...c, color: color };
        }
        return c;
      })
    );
  };
  const addCourse = () => {
    setNewCourses((c) => [...c, { id: uuidv4(), name: "", color: "#FFF" }]);
  };
  const deleteCourse = (id) => {
    setNewCourses((x) => x.filter((c) => c.id !== id));
  };

  const getCourse = (course) => {
    return (
      <div style={{ padding: "10px" }}>
        <div>{course.name}</div>
        <div id={`color-button-${course.id}`}>
          <IconButton onClick={() => deleteCourse(course.id)}>
            <DeleteIcon />
          </IconButton>
          <IconButton onClick={() => openColor(course.id)}>
            <FormatColorFillIcon />
          </IconButton>
          <input
            value={course.name}
            onChange={(e) => updateName(course.id, e.target.value)}
            style={getCourseStyle(course.color)}
          ></input>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {newCourses.map((c) => getCourse(c))}
      </div>
      <div
        style={{
          paddingBottom: "10px",
          marginBottom: "20px",
          borderBottom: "1px solid #333",
        }}
      >
        <Button variant="contained" onClick={addCourse}>
          Add Course
        </Button>
        <Button variant="contained" onClick={saveCourses}>
          Save Courses
        </Button>
      </div>
      {current && (
        <Popover
          id="mouse-over-popover"
          open={current}
          anchorEl={popoverAnchor.current}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div ref={popOver}>
            <HexColorPicker
              color={current?.color ? current.color : "#000"}
              onChange={(c) => updateColor(current, c)}
            />
          </div>
        </Popover>
      )}
    </Fragment>
  );
}
